export default __webpack_public_path__ + "static/media/udemy.c765819a.PNG";